import { render, staticRenderFns } from "./SubjectsIndex.vue?vue&type=template&id=1fc47b2d"
import script from "./SubjectsIndex.vue?vue&type=script&lang=js"
export * from "./SubjectsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports